// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"56b31daa","453":"258b012d","732":"2ca6096e"}[chunkId] + ".chunk.js";
};